import React,{useContext} from 'react'
import { AppContext } from '../../context';

import { Image } from "react-bootstrap";
import video from "../../assets/images/screen-recording/Easily-share-your-screen-1.png"

function AiDiscription() {

  const { videoData } = useContext(AppContext);
  console.log(videoData,"8790-98790-98768908767890876578907")



  return (
    <>
      <main className="contentarea text-start">
        <section className="selectLang">
          <div className="container">
            <div className="row align-items-center" >
              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                <div className="uploadvideo">
            
                    <video width="320" height="240" controls>
                         <source src={videoData ? videoData :""} type="video/mp4" />
                    </video>
                   
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                <div className="videoDetail">
                  <ul>
                    <li>Your Score : 90%</li>
                    <li>Emotion : Happy</li>
                  </ul>
                </div>
              </div>
            </div>
          
          <div className="row mt-4">
            <div className="col-12 col-md-12 col-md-12 col-lg-12">
              <h3>Transcript</h3>
              <div className="videotext originalResultDiv mt-3">
                <p>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout.
                  The point of using Lorem Ipsum is that it has a more-or-less
                  normal distribution of letters, as opposed to using 'Content
                  here, content here', making it look like readable English.
                </p>
              </div>
            </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default AiDiscription;
